export const ROSTER_STACK_BREAKPOINT = "(max-width: 900px)";
export const ROSTER_MOBILE_INITIAL = 8;
export const ROSTER_MOBILE_STEP = 8;

export const sliceRosterSections = (sections, limit, selectedId, getItemId) => {
  const flatCount = sections.reduce((total, section) => total + section.data.length, 0);
  if (!limit || flatCount <= limit) {
    return { displaySections: sections, hiddenCount: 0 };
  }

  let selectedRow = null;
  if (selectedId) {
    for (const section of sections) {
      const found = section.data.find(
        (row) => String(getItemId(row)) === String(selectedId)
      );
      if (found) {
        selectedRow = found;
        break;
      }
    }
  }

  const takeRows = (rows, max) => {
    const picked = [];
    let remaining = max;
    for (const row of rows) {
      if (remaining <= 0) break;
      picked.push(row);
      remaining -= 1;
    }
    return picked;
  };

  let remaining = limit;
  const result = [];
  let selectedVisible = false;

  for (const section of sections) {
    if (remaining <= 0) break;
    const slice = takeRows(section.data, remaining);
    if (
      selectedRow &&
      slice.some((row) => String(getItemId(row)) === String(selectedId))
    ) {
      selectedVisible = true;
    }
    if (slice.length) {
      result.push({ ...section, data: slice });
      remaining -= slice.length;
    }
  }

  if (selectedRow && !selectedVisible) {
    const restLimit = Math.max(limit - 1, 0);
    let restRemaining = restLimit;
    const rest = [];

    for (const section of sections) {
      if (restRemaining <= 0) break;
      const filtered = section.data.filter(
        (row) => String(getItemId(row)) !== String(selectedId)
      );
      const slice = takeRows(filtered, restRemaining);
      if (slice.length) {
        rest.push({ ...section, data: slice });
        restRemaining -= slice.length;
      }
    }

    const anchor = sections[0] || { dateKey: "selected", title: "Today", data: [] };
    return {
      displaySections: [{ ...anchor, data: [selectedRow] }, ...rest],
      hiddenCount: Math.max(0, flatCount - limit),
    };
  }

  return {
    displaySections: result,
    hiddenCount: Math.max(0, flatCount - limit),
  };
};
